import { render } from "./PricingSmallScreenLayout.vue?vue&type=template&id=ab429ee4"
import script from "./PricingSmallScreenLayout.vue?vue&type=script&lang=js"
export * from "./PricingSmallScreenLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__